import PageErrorContent from "../../../app/PageErrorContent";

function MobileAppPageError(props) {
    const {
        children,
        ...pageErrorContentProps
    } = props;

    return <div className="px-3 d-flex flex-column justify-content-center w-100 h-100 pb-5">
        <PageErrorContent {...pageErrorContentProps}>
            {children}
        </PageErrorContent>
    </div>
}

export default MobileAppPageError;
